/* eslint-disable react/button-has-type */
import React, { useState, useEffect, } from 'react'
import { Modal, Pagination, Spin, message } from 'antd'
import classnames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import no_goods from '../../image/no_goods.png'
import { AddGoods, DeleteButton, InputSearch, GoodsInfo } from './upgrade.common'
import './upgradeModal.less'

let clearId = 0
export default function GoodsInfoBox({ value, onAdd, onDelete }) {
  const pageSize = 30
  const [modalVisible, setModalVisible] = useState(false)
  const [keyword, setKeyword] = useState('')
  const [goods, setGoods] = useState({ resultList: [], resultCount: 0 })
  const [pageNo, setPageNo] = useState(1)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (!modalVisible) { return }
    clearTimeout(clearId)
    clearId = setTimeout(() => {
      if (!keyword) {
        fetchItems()
      } else {
        events.onSearch()
      }
    }, 600)
  }, [modalVisible, keyword])
  const fetchItems = async (_pageNo = 1) => {
    try {
      const firstRes = await request.sget('/v2-5-4/recent/view/taobao-item', { pageNo: _pageNo, pageSize: 30 })
      setGoods(firstRes)
    } catch (err) {
      console.error(err)
    }
  }
  const events = {
    async onSearch(_pageNo = 1) {
      setLoading(true)
      const res = await request.spost('/ins-item-search', {
        pageSize: 30,
        itemLikeName: keyword,
        _pageNo
      }, '/ins-item-search')
      setLoading(false)
      setGoods(res)
      setPageNo(_pageNo)
    },
    onClear(_goods, e) {
      e.stopPropagation()
      onDelete(_goods)
    },
    onClickItem(_goods) {
      onAdd(_goods)
      setModalVisible(false)
      message.success('选择成功')
    },
    onClickAdd() {
      setModalVisible(true)
    },
    onChangePage(_pageNo) {
      setPageNo(_pageNo)
      if (!keyword) {
        fetchItems(_pageNo)
      } else {
        events.onSearch(_pageNo)
      }
    }
  }
  return <div className="goods-info">
    {modalVisible ? <Modal
      title={<span style={{ color: 'var(--m-text-1)' }}>添加电商灵感</span>}
      className="ins-detail-info-modal ins-detail-goods-info-modal"
      width={556}
      bodyStyle={{ display: 'flex', flexDirection: 'column', height: 600 }}
      centered
      visible={modalVisible}
      footer={null}
      onCancel={() => setModalVisible(false)}
    >
      <InputSearch value={keyword} placeholder="请输入知衣链接或商品标题进行搜索" onChange={e => setKeyword(e.target.value)} />
      {!loading && goods.resultList.length === 0 ? <NoResult />
        : <><Spin wrapperClassName="goods-list custom-scroll-bar" indicator={<Icon type="m-jiazaizhong" spin />} spinning={loading}>
          {goods.resultList?.map(m => <GoodsInfo
            size="small"
            onClick={() => events.onClickItem(m)}
            key={m.itemId}
            data={m}
            imgSlot={
              <div className={classnames('mask', { selected: value?.itemId === m.itemId })}>
                <Icon className="se" type="m-guanbi" style={{ fontSize: 24, color: '#fff' }} />
              </div>
          }
          />)}
        </Spin>
          <div className="pageination-warp">
            共 {goods.resultCount} 条，每页 {pageSize} 条
            <Pagination
              className="goods-list-page"
              pageSize={pageSize}
              hideOnSinglePage
              current={pageNo}
              size="small"
              showSizeChanger={false}
              total={goods.resultCount}
              onChange={events.onChangePage}
            />
          </div>
        </>}
    </Modal> : null}
    {value?.length >= 5 ? null : <AddGoods title="添加商品" onClick={events.onClickAdd} />}
    {value?.length > 0 ? value.map((m) => {
      return <GoodsInfo
        data={m}
        size="mn-item-goods"
        deleteSlot={<div className="goods-info-item-mask"><DeleteButton iconType="mnyichu" onClick={e => events.onClear(m, e)} /></div>}
      />
    }) : null}
  </div>
}
function NoResult() {
  return <div className="no-result">
    <img src={no_goods} alt="" />
    <div style={{ fontSize: 14, color: '#262626', marginBottom: 8 }}>暂无相关商品</div>
    <div style={{ fontSize: 12, color: 'var(--m-text-3)', marginBottom: 16 }}>请修改信息或进入知衣-商品库添加收录</div>
    <button className="ins-button ghost" onClick={() => window.open('/process/4')}>去收录</button>
  </div>
}
